import React from 'react';

import Wizard from './../../DegreeDocumentPrint/Wizard';

export default () => <Wizard sService />;



// WEBPACK FOOTER //
// ./src/views/StudentService/FilterStudents/LockedStudents.js